module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/btn-stopp@3x.png?0.0.53";